import { FormDatepicker } from '@moneyforward/ap-frontend-components';
import { memo } from 'react';
import { Control, FieldPath, FieldValues } from 'react-hook-form';

type Props<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>;
  name: FieldPath<TFieldValues>;
};

const _BookDateEdit = <TFieldValues extends FieldValues>({
  control,
  name,
}: Props<TFieldValues>) => {
  return (
    <div
      data-testid='book-date-edit-container'
      // eslint-disable-next-line @moneyforward/account-payable/literals-in-props
      style={{ width: '100%' }}
    >
      <FormDatepicker<TFieldValues>
        control={control}
        name={name}
        inputId='book-date'
        testId='book-date'
        single
      />
    </div>
  );
};

_BookDateEdit.displayName = '_BookDateEdit';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const BookDateEdit = memo((props) => {
  return <_BookDateEdit {...props} />;
}) as typeof _BookDateEdit;
BookDateEdit.displayName = 'BookDateEdit';
